import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, InputNumber, message } from "antd";
import ModalCommon from "../../components/Modal";

const TEXT = {
    sencond: "Số giây mỗi lượt",
    numOfSoccer: "Số lượng bóng mỗi lượt",
    speed: "Tốc độ rơi",
    bomRate: "Tỉ lệ (%) boom theo VIP"
}

const SetupGameplay = () => {
    const [configGame, setConfigGame] = useState();
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    const [vip0_5, setVip0_5] = useState();
    const [vip6_11, setVip6_11] = useState();
    const [vip12_15, setVip12_15] = useState();
    const [vip16_20, setVip16_20] = useState();

    const [turnDuration, setTurnDuration] = useState();
    const [totalSymbols, setTotalSymbols] = useState();
    const [fallSpeed, setFallSpeed] = useState();
    const [messageApi, contextHolder] = message.useMessage();

    useEffect(() => {
        getDataConfig();
    }, []);

    const getDataConfig = async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            // API response format: { data: { ... } } or { ... }
            const responseData = res.data?.data || res.data;
            const vipLevels = responseData?.vipLevels || {};
            
            setConfigGame({
                turnDuration: responseData?.turnDuration,
                totalSymbols: responseData?.totalSymbols,
                fallSpeed: responseData?.fallSpeed,
                vip0_5: vipLevels["VIP_0_5"],
                vip6_11: vipLevels["VIP_6_11"],
                vip12_15: vipLevels["VIP_12_15"],
                vip16_20: vipLevels["VIP_16_20"]
            });

            setVip0_5(vipLevels["VIP_0_5"]?.BOMB_RATE);
            setVip6_11(vipLevels["VIP_6_11"]?.BOMB_RATE);
            setVip12_15(vipLevels["VIP_12_15"]?.BOMB_RATE);
            setVip16_20(vipLevels["VIP_16_20"]?.BOMB_RATE);
            setTurnDuration(responseData?.turnDuration);
            setTotalSymbols(responseData?.totalSymbols);
            setFallSpeed(responseData?.fallSpeed);
        } catch (err) {
            // Error handling
        }
    };

    const handleChangeInput = (e, key) => {
        const percentToBombRate = (v) => {
            if (v === null || v === undefined) return undefined;
            return Math.round(v * 100) / 10000;
        };
        switch (key) {
            case 1: setTurnDuration(e); return;
            case 2: setTotalSymbols(e); return;
            case 3: setFallSpeed(e); return;
            case 4: setVip0_5(percentToBombRate(e)); return;
            case 5: setVip6_11(percentToBombRate(e)); return;
            case 6: setVip12_15(percentToBombRate(e)); return;
            case 7: setVip16_20(percentToBombRate(e)); return;
            default: return;
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);
            
            // Use the new values if provided, otherwise use existing values from configGame
            const finalTurnDuration = turnDuration !== undefined && turnDuration !== null ? turnDuration : configGame?.turnDuration;
            const finalTotalSymbols = totalSymbols !== undefined && totalSymbols !== null ? totalSymbols : configGame?.totalSymbols;
            const finalFallSpeed = fallSpeed !== undefined && fallSpeed !== null ? fallSpeed : configGame?.fallSpeed;
            
            // Validate only if we have values
            if (
                (finalTurnDuration !== undefined && finalTurnDuration !== null && (!validNumber(finalTurnDuration))) ||
                (finalTotalSymbols !== undefined && finalTotalSymbols !== null && (!validNumber(finalTotalSymbols))) ||
                (finalFallSpeed !== undefined && finalFallSpeed !== null && (!validNumber(finalFallSpeed)))
            ) {
                showError("Vui lòng nhập số hợp lệ");
                return;
            }
            
            const body = {
                config: {
                    turnDuration: finalTurnDuration,
                    totalSymbols: finalTotalSymbols,
                    fallSpeed: finalFallSpeed,
                    vipLevels: {
                        VIP_0_5: vip0_5 !== undefined && vip0_5 !== null 
                            ? { 
                                MAX_SCORE: configGame?.vip0_5?.MAX_SCORE,
                                MIN_SCORE: configGame?.vip0_5?.MIN_SCORE,
                                BOMB_RATE: vip0_5,
                                PERSON_RATE: configGame?.vip0_5?.PERSON_RATE
                            } 
                            : configGame?.vip0_5,
                        VIP_6_11: vip6_11 !== undefined && vip6_11 !== null 
                            ? { 
                                MAX_SCORE: configGame?.vip6_11?.MAX_SCORE,
                                MIN_SCORE: configGame?.vip6_11?.MIN_SCORE,
                                BOMB_RATE: vip6_11,
                                PERSON_RATE: configGame?.vip6_11?.PERSON_RATE
                            } 
                            : configGame?.vip6_11,
                        VIP_12_15: vip12_15 !== undefined && vip12_15 !== null 
                            ? { 
                                MAX_SCORE: configGame?.vip12_15?.MAX_SCORE,
                                MIN_SCORE: configGame?.vip12_15?.MIN_SCORE,
                                BOMB_RATE: vip12_15,
                                PERSON_RATE: configGame?.vip12_15?.PERSON_RATE
                            } 
                            : configGame?.vip12_15,
                        VIP_16_20: vip16_20 !== undefined && vip16_20 !== null 
                            ? { 
                                MAX_SCORE: configGame?.vip16_20?.MAX_SCORE,
                                MIN_SCORE: configGame?.vip16_20?.MIN_SCORE,
                                BOMB_RATE: vip16_20,
                                PERSON_RATE: configGame?.vip16_20?.PERSON_RATE
                            } 
                            : configGame?.vip16_20,
                    }
                }
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
            
            // Only show success modal after API call succeeds
            setIsShowModalSuccess(true);
            
            // Update configGame with the values that were just submitted
            setConfigGame({
                ...configGame,
                turnDuration: finalTurnDuration,
                totalSymbols: finalTotalSymbols,
                fallSpeed: finalFallSpeed,
                vip0_5: vip0_5 !== undefined && vip0_5 !== null 
                    ? { 
                        MAX_SCORE: configGame?.vip0_5?.MAX_SCORE,
                        MIN_SCORE: configGame?.vip0_5?.MIN_SCORE,
                        BOMB_RATE: vip0_5,
                        PERSON_RATE: configGame?.vip0_5?.PERSON_RATE
                    } 
                    : configGame?.vip0_5,
                vip6_11: vip6_11 !== undefined && vip6_11 !== null 
                    ? { 
                        MAX_SCORE: configGame?.vip6_11?.MAX_SCORE,
                        MIN_SCORE: configGame?.vip6_11?.MIN_SCORE,
                        BOMB_RATE: vip6_11,
                        PERSON_RATE: configGame?.vip6_11?.PERSON_RATE
                    } 
                    : configGame?.vip6_11,
                vip12_15: vip12_15 !== undefined && vip12_15 !== null 
                    ? { 
                        MAX_SCORE: configGame?.vip12_15?.MAX_SCORE,
                        MIN_SCORE: configGame?.vip12_15?.MIN_SCORE,
                        BOMB_RATE: vip12_15,
                        PERSON_RATE: configGame?.vip12_15?.PERSON_RATE
                    } 
                    : configGame?.vip12_15,
                vip16_20: vip16_20 !== undefined && vip16_20 !== null 
                    ? { 
                        MAX_SCORE: configGame?.vip16_20?.MAX_SCORE,
                        MIN_SCORE: configGame?.vip16_20?.MIN_SCORE,
                        BOMB_RATE: vip16_20,
                        PERSON_RATE: configGame?.vip16_20?.PERSON_RATE
                    } 
                    : configGame?.vip16_20,
            });
            
            // Reset states to undefined so UI will use values from configGame
            setTurnDuration(undefined);
            setTotalSymbols(undefined);
            setFallSpeed(undefined);
            setVip0_5(undefined);
            setVip6_11(undefined);
            setVip12_15(undefined);
            setVip16_20(undefined);
        } catch (err) {
            const errorMessage = err.response?.data?.message || err.response?.data?.error || err.data?.message || err.data?.error || err.message || "Cập nhật thất bại";
            showError(errorMessage);
        }
    };

    const validNumber = (value) => {
        if (value === undefined || value === null || value === "") {
            return false;
        }
        const number = Number(value);
        // Allow any positive number including decimals, no upper limit
        return !isNaN(number) && number > 0 && isFinite(number);
    }

    const showError = (errorMessage) => {
        messageApi.open({
        type: 'error',
        content: errorMessage,
        });
    };


    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const formatPercentVip = (val, info) => {
        if (info?.userTyping) return info?.input ?? "";
        if (val === null || val === undefined || val === "") return "";
        const n = Number(val);
        if (Number.isNaN(n)) return String(val);
        if (n % 1 === 0) return String(n);
        return (Math.round(n * 10) / 10).toString();
    };

    const parsePercentVip = (str) => {
        if (str == null) return str;
        const s = String(str).replace(/[^\d.-]/g, "");
        return s;
    };

    const renderInputNumer = (key, value, changeInput, max, label, { precision = 0, step = 1, trimIntegerDisplay = false } = {}) => {
        const common = {
            key,
            style: { width: "100%" },
            value,
            onChange: changeInput,
            max: max || undefined,
            min: 0,
        };
        return (
            <div className={`flex w-full items-center ${key !== "vip0_5" ? "mt-4" : ""}`}>
                <div className="flex w-[20%] justify-end mr-10">{label}:</div>
                <div className="w-[60%]">
                    {trimIntegerDisplay ? (
                        <InputNumber
                            {...common}
                            step={step}
                            formatter={formatPercentVip}
                            parser={parsePercentVip}
                        />
                    ) : (
                        <InputNumber
                            {...common}
                            precision={precision}
                            step={step}
                        />
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="col-12">
            {contextHolder}
            {configGame && 
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                {configGame && renderInputNumer(
                                    "vip0_5",
                                    vip0_5 !== undefined && vip0_5 !== null 
                                        ? Math.round(vip0_5 * 10000) / 100 
                                        : (configGame?.vip0_5?.BOMB_RATE ? Math.round(configGame.vip0_5.BOMB_RATE * 10000) / 100 : undefined), 
                                    (e) => handleChangeInput(e, 4), 
                                    100, `${TEXT.bomRate} 0 - 5`,
                                    { step: 0.1, trimIntegerDisplay: true },
                                )}

                                {configGame && renderInputNumer(
                                    "vip6_11",
                                    vip6_11 !== undefined && vip6_11 !== null 
                                        ? Math.round(vip6_11 * 10000) / 100 
                                        : (configGame?.vip6_11?.BOMB_RATE ? Math.round(configGame.vip6_11.BOMB_RATE * 10000) / 100 : undefined), 
                                    (e) => handleChangeInput(e, 5), 
                                    100, `${TEXT.bomRate} 6 - 11`,
                                    { step: 0.1, trimIntegerDisplay: true },
                                )}

                                {configGame && renderInputNumer(
                                    "vip12_15",
                                    vip12_15 !== undefined && vip12_15 !== null 
                                        ? Math.round(vip12_15 * 10000) / 100 
                                        : (configGame?.vip12_15?.BOMB_RATE ? Math.round(configGame.vip12_15.BOMB_RATE * 10000) / 100 : undefined), 
                                    (e) => handleChangeInput(e, 6), 
                                    100, `${TEXT.bomRate} 12 - 15`,
                                    { step: 0.1, trimIntegerDisplay: true },
                                )}

                                {configGame && renderInputNumer(
                                    "vip16_20",
                                    vip16_20 !== undefined && vip16_20 !== null 
                                        ? Math.round(vip16_20 * 10000) / 100 
                                        : (configGame?.vip16_20?.BOMB_RATE ? Math.round(configGame.vip16_20.BOMB_RATE * 10000) / 100 : undefined), 
                                    (e) => handleChangeInput(e, 7), 
                                    100, `${TEXT.bomRate} 16 - 20`,
                                    { step: 0.1, trimIntegerDisplay: true },
                                )}

                                {configGame && renderInputNumer(
                                    "turnDuration",
                                    turnDuration !== undefined && turnDuration !== null ? turnDuration : configGame?.turnDuration, 
                                    (e) => handleChangeInput(e, 1), 
                                    500, `${TEXT.sencond}`
                                )}

                                {renderInputNumer(
                                    "totalSymbols",
                                    totalSymbols !== undefined && totalSymbols !== null ? totalSymbols : configGame?.totalSymbols, 
                                    (e) => handleChangeInput(e, 2), 
                                    500, `${TEXT.numOfSoccer}`
                                )}

                                {renderInputNumer(
                                    "fallSpeed",
                                    fallSpeed !== undefined && fallSpeed !== null ? fallSpeed : configGame?.fallSpeed, 
                                    (e) => handleChangeInput(e, 3), 
                                    50000, `${TEXT.speed}`
                                )}
                            </div>
                            <div className="col-10 mt-5 flex items-center justify-center">
                                <Button type="primary" onClick={handleShowModal}>
                                    Cập nhật
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                    }}
                />
            )}
        </div>
    );
};

export default SetupGameplay;